import SubscriptionCategoryPrefix from "./subscription-category-prefix";

export default SubscriptionCategoryPrefix